// import React from "react";
// import { Typography } from "antd";
// import SidebarLayout from "./SidebarLayout";

// const { Title } = Typography;

// const DataInsights = () => {
//     return (
//         <SidebarLayout>
//             <Title level={3}>Data Insights</Title>
//             <div style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 textAlign: 'center',
//                 marginTop: '100px'
//             }}>
//                 <img
//                     src="/constructionhat2.png"
//                     alt="LEVRIDGE.AI"
//                     style={{
//                         margin: '20px 0',
//                         display: 'block',
//                         maxWidth: '14%',
//                     }}
//                 />
//                 <div className="underconstruciton-box">
//                     <h2>Under construction</h2>
//                 </div>
//             </div>
//         </SidebarLayout>
//     );

// }

// export default DataInsights;



import React, { useEffect, useState } from "react";
import { Typography, Spin,Input, Button, Form } from "antd";
import { SendOutlined } from "@ant-design/icons";
import SidebarLayout from "./SidebarLayout";
import EchoChat from "../NewApplication/EchoChat";
import EchoChatForAdmin from "../NewApplication/EchoChatForAdmin";


const { Title } = Typography;

const DataInsightsForBanker = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                {/* <Title level={3}>Data Insights</Title> */}

                <div>

                    <EchoChatForAdmin />
                </div>
                {/* <div
                style={{
                    height: "90%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f5f6fa",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "500px",
                        maxWidth: "90%",
                        border: "1px solid #e0e0e0",
                        borderRadius: "20px",
                        padding: "5px 10px",
                        background: "#fff",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                >
                    <Input
                        placeholder="Here to Help..."
                        bordered={false}
                        style={{ flex: 1, fontSize: "16px" }}
                    />

                    <Form.Item style={{ margin: 5 }}>
                        <Button type="primary">
                            <SendOutlined />
                        </Button>
                    </Form.Item>
                </div>
            </div> */}
            </SidebarLayout>
        </Spin>
    );
};

export default DataInsightsForBanker;